import { createAsyncThunk } from '@reduxjs/toolkit';
import { Dispatch, SetStateAction } from 'react';
import {
  getEventTicketsAsync,
  getUserTicketsAsync,
  createEventTicketAsync
} from './Event.request';
import { eventData } from './EventData';
import { ErrorToast } from '../../components';

export const getEventTickets = createAsyncThunk(
  'getEventTickets',
  async (id: number) => {
    const { data } = await getEventTicketsAsync(id);

    const userTickets = await getUserTicketsAsync();

    const eventTickets = data;

    const newEventTickets = eventTickets?.map((ticket) => {
      let item = eventData.find((i) => i.id === ticket.id);
      return item
        ? {
            ...item,
            ...ticket
          }
        : ticket;
    });

    return {
      eventTickets: newEventTickets,
      userTickets: {
        ...userTickets
      }
    };
  }
);

export const createEventTicket = createAsyncThunk(
  'createEventTicket',
  async ({
    eventTicketId,
    currencyType,
    networkType,
    step,
    setStep
  }: {
    eventTicketId: number;
    currencyType: number;
    networkType: number | null;
    step: number;
    setStep: Dispatch<SetStateAction<number>>;
  }) => {
    try {
      const { data } = await createEventTicketAsync({
        eventTicketId,
        currencyType,
        networkType
      });

      setStep(step);

      return {
        eventTicket: data!.order
      };
    } catch (error: any) {
      ErrorToast(error.response.data.error);
    }
  }
);
